import { atom } from 'jotai';
import { createRequestAtom } from '../../../../../../shared/utils/request-atom';
import { CustomFieldConditionValue, CustomFieldFilterMetadata, SelectValueLabel } from './typings';

export const customFieldFilterMetadataAtom = createRequestAtom<CustomFieldFilterMetadata>();

export const customFieldSelectLabelsAtom = atom<Record<string, SelectValueLabel[]>>({});

export const customFieldPickerAnchorAtom = atom<HTMLElement | null>(null);

export interface CustomFieldValuePickerState {
  anchor: HTMLElement;
  fieldId: string;
  editIndex: number;
  prefill?: CustomFieldConditionValue;
}

export const customFieldValuePickerAtom = atom<CustomFieldValuePickerState | null>(null);
